<script setup>
import AdvancedLlmManager from '@/views/apps/llm/list/AdvancedLlmManager.vue';

definePage({
  meta: {
    action: 'read',
    subject: 'llms',
  },
})
</script>

<template>
  <section>
    <AdvancedLlmManager></AdvancedLlmManager>
  </section>
</template>
